import React from 'react'
import PropTypes from 'prop-types'

import { isSuperUser } from 'utils/Auth'

import Styles from './index.scss'

const Item = props => (
  <tr>
    <td>{props.no}</td>
    <td className={Styles.checkboxHeader}>
      <input
        type="checkbox"
        onChange={props.onClickCheckBox}
        checked={props.isDataSelected}
      />
    </td>
    {props.selectedData.id === props.tag.id ? (
      <td>
        <input
          className={Styles['input-edit']}
          onChange={props.onChangeValueSelected}
          value={props.selectedData.name}
        />
      </td>
    ) : (
        <td>
          {props.tag.name}
        </td>
      )}
    {props.selectedData.id === props.tag.id ? (
      <td>
        <div>
          <button
            className={`${Styles.btn} ${Styles['btn-cancel']}`}
            onClick={props.onEditClick({
              id: '',
              name: '',
            })}
          >
            Cancel
          </button>
          <button
            className={`${Styles.btn} ${Styles['btn-confirm']}`}
            onClick={props.onConfirmEdit}
          >
            Confirm
          </button>
        </div>
      </td>
    ) : (
        isSuperUser(props.user) &&
        <td>
          <button
            className="material-icons pointer-type"
            onClick={props.onEditClick(props.tag)}
          >
            edit
        </button>
          <button
            className="material-icons pointer-type"
            onClick={props.onDeleteClick(true, props.tag.id)}
          >
            delete
        </button>
        </td>
      )}
  </tr>
)

Item.defaultProps = {
  no: 1,
  tag: {
    name: '',
  },
  onEditClick: () => { },
  onDeleteClick: () => { },
  selectedData: {
    id: '',
    name: '',
  },
  onChangeValueSelected: () => { },
  onConfirmEdit: () => { },
  user: {
    email: '',
  },
  onClickCheckBox: () => { },
  isDataSelected: false,
}

Item.propTypes = {
  no: PropTypes.number,
  tag: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.isRequired,
  }),
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  selectedData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  onChangeValueSelected: PropTypes.func,
  onConfirmEdit: PropTypes.func,
  user: PropTypes.shape({}),
  onClickCheckBox: PropTypes.func,
  isDataSelected: PropTypes.bool,
}

export default Item
